export default {
  page: {
    title: "Gestione lettori",
    subtitle:
      "Registra i lettori POS, abbina i terminali SumUp e collegali ai dispositivi",
    tabReaders: "Lettori",
    tabPresets: "Preset lettori",
    newReader: "Nuovo lettore",
    searchPlaceholder: "Cerca per numero seriale, marca, modello…",
    showMockReaders: "Mostra terminali mock",
    filterPairing: "Associazione",
    filterDeviceStatus: "Stato dispositivo",
    filterStatusAll: "Tutti",
    filterDeviceOnline: "Online",
    filterDeviceUnavailable: "Non disponibile",
    filterDeviceUnknown: "Non verificato",
    colBrand: "Marca",
    colSerial: "Numero seriale",
    colRegion: "Regione",
    colStatus: "Stato",
    colDevice: "Dispositivo assegnato",
    colActions: "Azioni",
    emptySearch: "Nessun lettore corrisponde alla ricerca.",
    emptyDefault: "Nessun lettore registrato.",
    deleteTitle: "Elimina lettore",
    deleteConfirm:
      "Eliminare il lettore \"{{serial}}\" dall'inventario? L'azione non può essere annullata.",
    deleteConfirmPaired:
      "Eliminare il lettore \"{{serial}}\"? Verrà disabbinato da SumUp e rimosso dall'inventario. L'azione non può essere annullata.",
    readerDeleted: "Lettore eliminato",
    readerRenamed: "Numero seriale del lettore aggiornato",
    readerCreated: "Lettore registrato",
    readerPaired: "Lettore abbinato a SumUp",
    readerUnpaired: "Lettore disabbinato da SumUp",
    statusCreated: "Creato",
    statusNotPaired: "Non associato",
    statusPaired: "Associato",
    deviceOnline: "Online",
    deviceOffline: "Offline",
    deviceBattery: "Batteria: {{level}}%",
    deviceState: {
      IDLE: "Inattivo",
      SELECTING_TIP: "Selezione mancia",
      UPDATING_FIRMWARE: "Aggiornamento firmware",
      WAITING_FOR_CARD: "In attesa della carta",
      WAITING_FOR_PIN: "In attesa del PIN",
      WAITING_FOR_SIGNATURE: "In attesa della firma",
      UNKNOWN: "Stato sconosciuto",
    },
    deviceLastChecked: "Ultimo controllo: {{time}}",
    deviceLastActivity: "Ultima attività: {{time}}",
    refreshAllDeviceStatuses: "Aggiorna stato dispositivi",
    deviceStatusesRefreshed: "Stati dei dispositivi aggiornati",
    deviceStatusesRefreshedPartial:
      "Aggiornati {{updated}} stati dispositivo; {{failed}} non riusciti",
    deviceStatusesRefreshFailed:
      "Impossibile aggiornare {{failed}} stati dispositivo",
    deviceStatusesNothingToRefresh:
      "Nessun lettore SumUp associato da aggiornare",
    regionLocked: "Bloccata",
    regionLockedHint:
      "La regione è bloccata dopo un pagamento riuscito e non può essere modificata",
    openAssignedDevice: "Apri dispositivo {{name}}",
    pairAction: "Abbina a SumUp",
    unpairAction: "Disabbina da SumUp",
    unlinkFromDeviceAction: "Scollega dal dispositivo",
    unlinkFromDeviceConfirm:
      'Scollegare il lettore "{{serial}}" dal dispositivo "{{device}}"? L’abbinamento SumUp resta; i pagamenti restano disabilitati finché non lo colleghi di nuovo.',
    readerUnlinkedFromDevice: "Lettore scollegato dal dispositivo",
    changeRegionAction: "Cambia regione",
    regionUpdated: "Regione del lettore aggiornata",
    unpairConfirm:
      'Disabbinare il lettore "{{serial}}" da SumUp? Rimarrà in inventario.',
  },
  renameModal: {
    title: "Rinomina lettore",
    help: "Aggiorna il numero seriale del lettore {{serial}}.",
    serialLabel: "Numero seriale",
    serialPlaceholder: "Inserisci il numero seriale del dispositivo",
    serialRequired: "Il numero seriale è obbligatorio",
  },
  createModal: {
    title: "Registra lettore",
    serialLabel: "Numero seriale",
    serialPlaceholder: "Inserisci il numero seriale del dispositivo",
    serialRequired: "Il numero seriale è obbligatorio",
    regionLabel: "Regione",
    chooseRegion: "Seleziona regione…",
    regionRequired: "Seleziona una regione",
    presetSelectorTitle: "Scegli un preset lettore",
    presetsEmpty:
      "Nessun preset trovato. Creane uno prima dalla scheda Preset lettori.",
    presetCardSpecs: "{{model}} • {{provider}} • {{flow}}",
    presetRequired: "Seleziona un preset lettore",
    submit: "Registra lettore",
  },
  pairModal: {
    title: "Abbina lettore SumUp",
    help: "Inserisci il codice di abbinamento mostrato sul terminale {{serial}}.",
    codeLabel: "Codice di abbinamento",
    codePlaceholder: "8–9 caratteri",
    codeInvalid:
      "Inserisci il codice di abbinamento di 8–9 caratteri del dispositivo SumUp.",
    submit: "Abbina lettore",
  },
  changeRegionModal: {
    title: "Cambia regione del lettore",
    help: "Seleziona la regione di pagamento per il lettore {{serial}}.",
    regionLabel: "Regione",
    regionRequired: "La regione è obbligatoria",
    unpairWarning:
      "Questo lettore è abbinato a SumUp. Cambiare regione lo eliminerà da SumUp e cancellerà l'abbinamento locale.",
    unpairConfirm:
      'Cambiare regione per "{{serial}}"? L\'abbinamento SumUp verrà rimosso automaticamente.',
    submit: "Salva regione",
  },
  presets: {
    brandPlaceholder: "Marca (es. SumUp)",
    modelPlaceholder: "Modello (es. Solo)",
    providerPlaceholder: "Provider (es. SUMUP)",
    flowPlaceholder: "Flusso (es. CLOUD_POS)",
    add: "Aggiungi preset",
    save: "Salva modifiche",
    updated: "Preset aggiornato",
    created: "Preset creato",
    deleted: "Preset eliminato",
    deleteConfirm: 'Eliminare il preset "{{name}}"?',
    deleteTitle: "Elimina preset",
    editTitle: "Modifica preset",
    colBrand: "Marca",
    colModel: "Modello",
    colProvider: "Provider",
    colFlow: "Flusso",
    colActions: "Azioni",
    empty: "Nessun preset ancora.",
    validationRequired: "Compila tutti i campi del preset.",
  },
} as const;
